<section class="tw-bg-blue-50">
    <div class="tw-max-w-[1380px] tw-mx-auto tw-py-[50px] tw-px-[15px]">
        <div
            class="tw-flex tw-justify-center tw-w-[319px] tw-m-auto sm:tw-w-full"
        >
            <button
                class="tw-rounded-l-full tw-border tw-h-[40px] tw-w-[159.5px] tw-text-[13px] sm:tw-text-[16px] sm:tw-h-[60px] sm:tw-w-[260px] md:tw-text-[22px] tw-border-r-0 tw-border-[#7B7575]"
                [ngClass]="{
                    'tw-bg-[#4B6EEC] tw-text-white':
                        activeFinancingType === 'financing',
                    'tw-bg-transparent tw-text-[#7B7575]':
                        activeFinancingType !== 'financing',
                }"
                (click)="toggleFinancingType('financing')"
            >
                {{ "COMMON.FINANCING" | translate }}
            </button>
            <button
                class="tw-rounded-r-full tw-border tw-h-[40px] tw-w-[159.5px] tw-text-[13px] sm:tw-text-[16px] sm:tw-h-[60px] sm:tw-w-[260px] md:tw-text-[22px] tw-border-l-0 tw-border-[#7B7575]"
                [ngClass]="{
                    'tw-bg-[#4B6EEC] tw-text-white':
                        activeFinancingType === 'beyondFinancing',
                    'tw-bg-transparent tw-text-[#7B7575]':
                        activeFinancingType !== 'beyondFinancing',
                }"
                (click)="toggleFinancingType('beyondFinancing')"
            >
                {{ "COMMON.BEYOND_FINANCING" | translate }}
            </button>
        </div>
        <p
            class="!tw-text-center !tw-text-[14px] sm:!tw-text-[16px] !tw-max-w-[1020px] !tw-mx-auto !tw-px-[15px] md:!tw-px-0 !tw-py-5"
        >
            {{
                activeFinancingType === "financing"
                    ? ("PARTNERS.FINANCING_DESC" | translate)
                    : ("PARTNERS.BEYOND_FINANCING_DESC" | translate)
            }}
        </p>

        <!-- Financing section starts -->
        <ng-container *ngIf="activeFinancingType === 'financing'">
            <h3
                class="!tw-text-[20px] sm:!tw-text-[24px] !tw-text-[#0F3172] !tw-font-semibold !tw-mb-4"
            >
                {{ "COMMON.BANKS" | translate }}
            </h3>
            <div
                class="tw-grid tw-grid-cols-2 sm:tw-grid-cols-3 md:tw-grid-cols-4 lg:tw-grid-cols-5 tw-gap-8 tw-mt-[30px] tw-mb-[60px] md:tw-mb-[120px]"
            >
                <div
                    *ngFor="let item of bankProductsList"
                    class="tw-max-w-[140px] md:tw-max-w-[225px] tw-h-[140px] md:tw-h-[175px] tw-flex tw-items-center"
                >
                    <img
                        [src]="getImgUrl(item?.img)"
                        [alt]="item.org_code"
                        class="tw-w-full tw-mx-auto tw-max-h-[85px]"
                    />
                </div>
            </div>
            <h3
                class="!tw-text-[20px] sm:!tw-text-[24px] !tw-text-[#0F3172] !tw-font-semibold !tw-mb-4"
            >
                {{ "COMMON.ALTERNATE_FINANCING" | translate }}
            </h3>
            <div
                class="tw-grid tw-grid-cols-2 sm:tw-grid-cols-3 md:tw-grid-cols-4 lg:tw-grid-cols-5 tw-gap-8 tw-mt-[30px] tw-mb-[60px] md:tw-mb-[120px] tw-rounded"
            >
                <div
                    *ngFor="let item of p2pProductsList"
                    class="tw-max-w-[140px] md:tw-max-w-[225px] tw-h-[140px] md:tw-h-[175px] tw-flex tw-items-center"
                >
                    <img
                        [src]="getImgUrl(item?.img)"
                        [alt]="item.org_code"
                        class="tw-w-full tw-mx-auto tw-max-h-[85px]"
                    />
                </div>
            </div>
        </ng-container>
        <!-- Financing section ends -->
        <!-- Beyond Financing section starts -->
        <ng-container *ngIf="activeFinancingType === 'beyondFinancing'">
            <h3
                class="!tw-text-[20px] sm:!tw-text-[24px] !tw-text-[#0F3172] !tw-font-semibold !tw-mb-4"
            >
                {{ "COMMON.INSURANCE" | translate }}
            </h3>
            <div
                class="tw-grid tw-grid-cols-2 sm:tw-grid-cols-3 md:tw-grid-cols-4 lg:tw-grid-cols-5 tw-gap-8 tw-mt-[30px] tw-mb-[60px] md:tw-mb-[120px] tw-items-center"
            >
                <div
                    *ngFor="let item of insuranceList"
                    class="tw-max-w-[140px] md:tw-max-w-[225px] tw-h-[140px] md:tw-h-[175px] tw-flex tw-items-center"
                >
                    <img
                        [src]="getImgUrl(item?.img)"
                        [alt]="item?.name || 'Insurance Image'"
                        class="tw-w-full tw-mx-auto"
                    />
                </div>
            </div>
            <!-- display technology services partners from imsme/agency API -->
            <h3
                class="!tw-text-[20px] sm:!tw-text-[24px] !tw-text-[#0F3172] !tw-font-semibold !tw-mb-4"
            >
                {{ "PARTNERS.TECHNOLOGY_SERVICES" | translate }}
            </h3>
            <div
                class="tw-grid tw-grid-cols-2 sm:tw-grid-cols-3 md:tw-grid-cols-4 lg:tw-grid-cols-5 tw-gap-8 tw-mt-[30px] tw-mb-[60px] md:tw-mb-[120px]"
            >
                <div
                    class="tw-max-w-[140px] md:tw-max-w-[225px] tw-h-[140px] md:tw-h-[175px] tw-flex tw-items-center"
                >
                    <img
                        [src]="partnershipImgUrls"
                        alt="Technology And Services Image"
                        class="tw-w-full tw-mx-auto"
                    />
                </div>
                <div
                    class="tw-max-w-[140px] md:tw-max-w-[225px] tw-h-[140px] md:tw-h-[175px] tw-flex tw-items-center"
                    *ngFor="let item of techServicesList"
                >
                    <img
                        [src]="getImgUrl(item?.img)"
                        [alt]="item.org_code"
                        class="tw-w-full tw-mx-auto"
                    />
                </div>
            </div>
        </ng-container>
        <!-- Beyond Financing section ends -->
    </div>
</section>
